import { SxProps, Theme } from '@mui/material/styles'

import { MotivationDiagnosisCategory } from '../types'

/**
 * Returns the per-category accent colour drawn from the theme. Blind spots
 * use `error` (not `warning`) so the "what's not working" half of the section
 * lands with the urgency the title promises — `warning` orange read as too
 * gentle next to the green alignment column.
 *
 * Shared by the single-game diagnosis and the game-vs-game comparison so the
 * two diagnostics cannot drift to different accents.
 */
export function categoryColor(theme: Theme, category: MotivationDiagnosisCategory): string {
  switch (category) {
    case 'aligned':
      return theme.palette.success.main
    case 'blind_spot':
      return theme.palette.error.main
  }
}

/**
 * Trailing two-score readout on a diagnosis card (delivered / target), ordered
 * to match the gap bar's left→right reading. Scales up in sympathy with the bar
 * via the `gap-bar-scores` class.
 */
export const diagnosisScoresSx: SxProps<Theme> = {
  flexShrink: 0,
  textAlign: 'right',
  fontSize: '0.8rem',
  fontWeight: 700,
  fontVariantNumeric: 'tabular-nums',
  lineHeight: 1.2,
  transformOrigin: 'right center',
  transition: 'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
}
